import type { PipSkin } from '@/ui/pip-skins'

export const PIP_WINDOW_SIZE_KEY = 'maple-log:pip-window-size'
export const PIP_RESIZE_TUTORIAL_KEY = 'maple-log:pip-resize-tutorial-seen'

export interface PipWindowSize { width: number; height: number }

function validSize(value: unknown): value is PipWindowSize {
  if (!value || typeof value !== 'object') return false
  const { width, height } = value as PipWindowSize
  return Number.isSafeInteger(width) && width > 0 && Number.isSafeInteger(height) && height > 0
}

// The new default must not inherit a differently shaped skin's saved viewport.
function sizeKey(skin?: PipSkin): string {
  return skin === 'daily-order' ? `${PIP_WINDOW_SIZE_KEY}:daily-order` : PIP_WINDOW_SIZE_KEY
}

export function readPipWindowSize(skin?: PipSkin): PipWindowSize | null {
  try {
    const value: unknown = JSON.parse(window.localStorage.getItem(sizeKey(skin)) ?? 'null')
    return validSize(value) ? { width: value.width, height: value.height } : null
  } catch { return null }
}

export function savePipWindowSize(size: PipWindowSize, skin?: PipSkin): boolean {
  if (!validSize(size)) return false
  try {
    window.localStorage.setItem(sizeKey(skin), JSON.stringify({ width: size.width, height: size.height }))
    return true
  } catch { return false }
}

export function readPipResizeTutorialSeen(): boolean {
  try { return window.localStorage.getItem(PIP_RESIZE_TUTORIAL_KEY) === '1' }
  catch { return false }
}

export function markPipResizeTutorialSeen(): boolean {
  try {
    window.localStorage.setItem(PIP_RESIZE_TUTORIAL_KEY, '1')
    return true
  } catch { return false }
}
